import { RouterPararms, RouterPaths } from "@/models";
import { Link } from "@tanstack/react-router";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "./ui/breadcrumb";

export interface BreadcrumbOptions<T extends RouterPaths = RouterPaths> {
  content: React.ReactNode;
  href: T;
  params?: RouterPararms<T>;
}

function interleaveNulls<T>(arr: T[]): (T | null)[] {
  // [1, 2, 3] => [1, null, 2, null, 3]
  return arr.reduce(
    (acc, curr, i) => {
      if (i === 0) {
        return [curr];
      }

      return [...acc, null, curr];
    },
    [] as (T | null)[]
  );
}

export function Breadcrumbs({ crumbs }: { crumbs: BreadcrumbOptions[] }) {
  return (
    <Breadcrumb>
      <BreadcrumbList>
        {interleaveNulls(crumbs).map((crumb, i, arr) => {
          if (crumb === null) {
            return <BreadcrumbSeparator className="hidden md:block" key={i} />;
          }
          if (i === arr.length - 1)
            return (
              <BreadcrumbPage
                className="flex items-center gap-1"
                key={i}
                id={i.toString()}
              >
                {crumb.content}
              </BreadcrumbPage>
            );
          return (
            <BreadcrumbItem
              className="hidden md:block"
              key={i}
              id={i.toString()}
            >
              <BreadcrumbLink asChild className="flex items-center gap-1">
                <Link to={crumb.href} params={crumb.params}>
                  {crumb.content}
                </Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
          );
        })}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
